{
  "name": "@uppy/status-bar",
  "description": "A progress bar for Uppy, with many bells and whistles.",
  "version": "5.1.0",
  "license": "MIT",
  "style": "dist/style.min.css",
  "type": "module",
  "sideEffects": [
    "*.css"
  ],
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "progress bar",
    "status bar",
    "progress",
    "upload",
    "eta",
    "speed"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./css/style.css": "./dist/style.css",
    "./css/style.min.css": "./dist/style.min.css",
    "./css/style.scss": "./src/style.scss",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@transloadit/prettier-bytes": "^0.3.4",
    "@uppy/utils": "workspace:^",
    "classnames": "^2.2.6",
    "preact": "^10.5.13"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "cssnano": "^7.0.7",
    "postcss": "^8.5.6",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^5.8.3"
  }
}
